<template>
  <div class="live-view" style="">
    <div style=" display: flex;">
      <Pannel
        :dateRange="dateRange"
        :stores="stores"
        :timezone="timezone || 'America/Los_Angeles'"
        :top-country="topCountry"
        :countryKeys="countryKeys"
        :last-refresh-ts="lastRefreshTs"
        :refresh-interval-ms="refreshIntervalMs"
      />

      <div v-show="!isMap && isDesktop" class="globe-container" ref="globeEl"></div>
      <div v-show="isMap && isDesktop" style=" width: 100%; position: relative; inset: 0; top: 0;"></div>
    </div>
    <div v-if="isMap && isDesktop">
      <MapView
        :centerLat="this.defaultViewValue.lat"
        :centerLng="this.defaultViewValue.lng"
        :zoom="5"
        :locations="shopList"
      />
    </div>
    <div v-show="isDesktop" style=" position: absolute; top: 10px; right: 20px; z-index: 2;">
      <v-btn outlined @click="handleToggle">
        <template v-if="isMap">
          <v-icon class="mr-1">mdi-earth</v-icon>
        </template>
        <template v-else>
          <v-icon class="mr-1">mdi-map</v-icon>
        </template>
      </v-btn>
    </div>
    <div v-if="selectedShop" class="shop-info-box" :style="infoBoxStyle">
      <span class="bold-text">{{ selectedShop.product_name }}</span
      ><br />
      Viewers: {{ selectedShop.count || 0 }} <br />Region: {{ selectedShop.region || '' }}
    </div>
  </div>
</template>

<script>
import STORAGE_NAME from '@/const/storage';
import { FETCH_TOTAL_SALES, FETCH_TOTAL_ORDERS } from '@/store/actions.type';
import moment from 'moment';
import { mapGetters } from 'vuex';
import Pannel from './Pannel.vue';
import MapView from './MapView.vue';
export default {
  name: 'LiveView',
  props: {
    dateRange: {
      from: Date,
      to: Date,
    },
    stores: Array,
    timezone: String,
    lastRefreshTs: {
      type: [Number, String],
      default: null,
    },
    refreshIntervalMs: {
      type: Number,
      default: 15000,
    },
  },
  components: {
    Pannel,
    MapView,
  },
  mounted() {
    const checkReady = () => {
      if (window.Globe && window.topojson && window.THREE) {
        setTimeout(this.initGlobe(), 1000);
      } else {
        setTimeout(checkReady, 100);
      }
    };
    checkReady();
    document.addEventListener('click', this.clearSelectedShop);
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // chạy lần đầu
  },
  data() {
    return {
      countries: [],
      filter: {
        page: 1,
      },
      isMap: false,
      defaultViewValue: {
        lat: 37.1,
        lng: -95.7,
      },
      shopList: [
        { id: 1, name: 'Shop A', lat: 40, lng: -90, description: 'Cửa hàng A' },
        { id: 2, name: 'Shop B', lat: 21.035, lng: 105.855, description: 'Cửa hàng B' },
      ],
      globeInstance: null,
      selectedShop: null,
      infoBoxStyle: {
        left: '0px',
        top: '0px',
      },
      isDesktop: window.innerWidth >= 1280,
      countryKeys: [
        { code: 'VN', value: 'Vietnam', flag: 'https://flagcdn.com/vn.svg' },
        { code: 'CN', value: 'China', flag: 'https://flagcdn.com/cn.svg' },
        { code: 'JP', value: 'Japan', flag: 'https://flagcdn.com/jp.svg' },
        { code: 'KR', value: 'South Korea', flag: 'https://flagcdn.com/kr.svg' },
        { code: 'IN', value: 'India', flag: 'https://flagcdn.com/in.svg' },
        { code: 'ID', value: 'Indonesia', flag: 'https://flagcdn.com/id.svg' },
        { code: 'TH', value: 'Thailand', flag: 'https://flagcdn.com/th.svg' },
        { code: 'MY', value: 'Malaysia', flag: 'https://flagcdn.com/my.svg' },
        { code: 'SG', value: 'Singapore', flag: 'https://flagcdn.com/sg.svg' },
        { code: 'PH', value: 'Philippines', flag: 'https://flagcdn.com/ph.svg' },
        { code: 'FR', value: 'France', flag: 'https://flagcdn.com/fr.svg' },
        { code: 'DE', value: 'Germany', flag: 'https://flagcdn.com/de.svg' },
        { code: 'GB', value: 'United Kingdom', flag: 'https://flagcdn.com/gb.svg' },
        { code: 'IT', value: 'Italy', flag: 'https://flagcdn.com/it.svg' },
        { code: 'ES', value: 'Spain', flag: 'https://flagcdn.com/es.svg' },
        { code: 'RU', value: 'Russia', flag: 'https://flagcdn.com/ru.svg' },
        { code: 'SE', value: 'Sweden', flag: 'https://flagcdn.com/se.svg' },
        { code: 'NO', value: 'Norway', flag: 'https://flagcdn.com/no.svg' },
        { code: 'NL', value: 'Netherlands', flag: 'https://flagcdn.com/nl.svg' },
        { code: 'PL', value: 'Poland', flag: 'https://flagcdn.com/pl.svg' },
        { code: 'US', value: 'United States', flag: 'https://flagcdn.com/us.svg' },
        { code: 'CA', value: 'Canada', flag: 'https://flagcdn.com/ca.svg' },
        { code: 'MX', value: 'Mexico', flag: 'https://flagcdn.com/mx.svg' },
        { code: 'BR', value: 'Brazil', flag: 'https://flagcdn.com/br.svg' },
        { code: 'AR', value: 'Argentina', flag: 'https://flagcdn.com/ar.svg' },
        { code: 'CL', value: 'Chile', flag: 'https://flagcdn.com/cl.svg' },
        { code: 'CO', value: 'Colombia', flag: 'https://flagcdn.com/co.svg' },
        { code: 'PE', value: 'Peru', flag: 'https://flagcdn.com/pe.svg' },
        { code: 'VE', value: 'Venezuela', flag: 'https://flagcdn.com/ve.svg' },
        { code: 'CU', value: 'Cuba', flag: 'https://flagcdn.com/cu.svg' },
        { code: 'ZA', value: 'South Africa', flag: 'https://flagcdn.com/za.svg' },
        { code: 'EG', value: 'Egypt', flag: 'https://flagcdn.com/eg.svg' },
        { code: 'NG', value: 'Nigeria', flag: 'https://flagcdn.com/ng.svg' },
        { code: 'KE', value: 'Kenya', flag: 'https://flagcdn.com/ke.svg' },
        { code: 'MA', value: 'Morocco', flag: 'https://flagcdn.com/ma.svg' },
        { code: 'DZ', value: 'Algeria', flag: 'https://flagcdn.com/dz.svg' },
        { code: 'ET', value: 'Ethiopia', flag: 'https://flagcdn.com/et.svg' },
        { code: 'GH', value: 'Ghana', flag: 'https://flagcdn.com/gh.svg' },
        { code: 'UG', value: 'Uganda', flag: 'https://flagcdn.com/ug.svg' },
        { code: 'SD', value: 'Sudan', flag: 'https://flagcdn.com/sd.svg' },
        { code: 'AU', value: 'Australia', flag: 'https://flagcdn.com/au.svg' },
        { code: 'NZ', value: 'New Zealand', flag: 'https://flagcdn.com/nz.svg' },
        { code: 'FJ', value: 'Fiji', flag: 'https://flagcdn.com/fj.svg' },
        { code: 'PG', value: 'Papua New Guinea', flag: 'https://flagcdn.com/pg.svg' },
        { code: 'WS', value: 'Samoa', flag: 'https://flagcdn.com/ws.svg' },
        { code: 'EU', value: 'European Union', flag: 'https://flagcdn.com/eu.svg' },
        { code: 'UN', value: 'United Nations', flag: 'https://flagcdn.com/un.svg' },
        { code: 'HK', value: 'Hong Kong', flag: 'https://flagcdn.com/hk.svg' },
        { code: 'TW', value: 'Taiwan', flag: 'https://flagcdn.com/tw.svg' },
      ],
    };
  },
  methods: {
    loadQueryFromCache() {
      let cacheQuery = localStorage.getItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
      return cacheQuery ? JSON.parse(cacheQuery) : {};
    },
    zipChartData() {
      const values = this.chartData.datasets[0].data || [];
      console.log('check dât chẻ', values);
      this.pageView = values[0] || 0;
      this.atc = values[1] || 0;
      this.reachedCheckout = values[2] || 0;
      this.sessionConverted = values[3] || 0;
    },
    initGlobe() {
      const globe = window
        .Globe()
        // .globeImageUrl('/admin/img/bg-globe.jpg')
        .backgroundColor('#F8F9FA')
        .showGlobe(true)
        .showAtmosphere(true)
        .atmosphereColor('#d0f0ff')
        .atmosphereAltitude(0.2)
        .hexPolygonResolution(3)
        .hexPolygonMargin(0.25)
        .hexPolygonColor(() => '#051b58')
        .hexPolygonsData([])
        .enablePointerInteraction(true);

      globe(this.$refs.globeEl);
      this.globeInstance = globe;

      this.$nextTick(() => {
        this.resizeGlobe();
      });

      globe.controls().autoRotate = false;
      globe.controls().enableZoom = false;
      globe.controls().enablePan = false;
      globe.camera().position.set(0, 0, 300);

      setTimeout(() => {
        const scene = globe.scene();
        const hemiLight = new window.THREE.HemisphereLight(0x6dd6cb, 0x6dd6cb, 1.2);
        scene.add(hemiLight);

        const backLight = new window.THREE.DirectionalLight(0x6dd6cb, 0.4);
        backLight.position.set(-2, 1, -2);
        scene.add(backLight);

        globe.globeMaterial().color.set('#5c7283');
        globe.globeMaterial().emissive.set('#5c7283');
        globe.globeMaterial().emissiveIntensity = 0.7;
      }, 500);

      fetch('/admin/img/ne_110m_admin_0_countries.geojson')
        .then(res => res.json())
        .then(countr => {
          if (!countr?.features) return;

          globe
            .hexPolygonsData(countr.features)
            .hexPolygonResolution(3)
            .hexPolygonMargin(0.3)
            .hexPolygonUseDots(false)
            .hexPolygonLabel(({ properties: d }) => {
              return `
            <b>${d.ADMIN} (${d.ISO_A2})</b>
          `;
            });
        });

      globe.pointOfView({ lat: this.defaultViewValue.lat, lng: this.defaultViewValue.lng, altitude: 1.5 }, 2000);

      const markerSvg = `<svg viewBox="-4 0 36 36">
    <path fill="currentColor" d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z"></path>
    <circle fill="black" cx="14" cy="14" r="7"></circle>
  </svg>`;

      // Render marker nếu có shopList ngay khi khởi tạo
      if (Array.isArray(this.shopList) && this.shopList.length) {
        globe
          .htmlElementsData(this.shopList)
          .htmlLat(d => d.lat)
          .htmlLng(d => d.lng)
          .htmlElement(d => {
            const el = document.createElement('div');
            el.innerHTML = markerSvg;
            el.style.color = 'red';
            el.style.width = '24px';
            el.style.position = 'absolute';
            el.style.transform = 'translate(-50%, -100%)';
            el.style.cursor = 'pointer';
            el.style.transition = 'opacity 0.3s';
            el.style.zIndex = '100';
            el.style.pointerEvents = 'auto';

            el.addEventListener('click', e => {
              e.stopPropagation();

              const rect = el.getBoundingClientRect();
              this.selectedShop = d;
              this.infoBoxStyle = {
                top: `${rect.top - 100}px`, // 60px để đưa info box lên trên marker
                left: `${rect.left + rect.width / 2 - 150}px`, // 100 = nửa chiều rộng của info box
              };
            });

            return el;
          });
      }
    },
    fetchRecords(filters) {
      this.loadingItems = true;
      let date = moment()
        .tz(this.timezone)
        .format('YYYY-MM-DD');
      this.$store
        .dispatch('trafficLocation', {
          ...filters,
          stores: this.stores,
          timezone: this.timezone,
          fromTime: this.dateRange.from || date,
          toTime: this.dateRange.to || date,
        })
        .then(() => {
          this.loadingItems = false;
        })
        .catch(() => {
          window._VMA.$emit('SHOW_SNACKBAR', {
            show: true,
            text: 'Auth Failed',
            color: 'error',
          });
          this.loadingItems = false;
        });
    },
    updateFilterQuery(query) {
      const filter = Object.assign(this.filter, this.transformQuery(query));
      return filter;
    },
    transformQuery(query) {
      const numbers = ['page'];
      for (let key in query) {
        if (numbers.includes(key)) {
          const val = query[key] ? parseInt(query[key]) : query[key];
          query[key] = val;
        }
      }
      return query;
    },
    handleToggle() {
      this.isMap = !this.isMap;
    },
    resizeGlobe() {
      if (!this.$refs.globeEl || !this.globeInstance) return;

      const { offsetWidth: width, offsetHeight: height } = this.$refs.globeEl;
      this.globeInstance.width([width]);
      this.globeInstance.height([height]);
      this.globeInstance.renderer().setSize(width, height);
      this.globeInstance.camera().aspect = width / height;
      this.globeInstance.camera().updateProjectionMatrix();
    },
    updateGlobeShops() {
      if (this.globeInstance && Array.isArray(this.shopList)) {
        const test = JSON.parse(JSON.stringify(this.shopList));
        this.globeInstance.htmlElementsData(test);
      }
    },
    clearSelectedShop() {
      this.selectedShop = null;
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= 1280;

      if (!this.isMap && this.isDesktop) {
        this.$nextTick(() => {
          this.resizeGlobe();
        });
      }
    },
  },
  async created() {},
  computed: {
    ...mapGetters(['chartData']),
    globeChart() {
      return this.$store.getters.globeChart;
    },
    topCountry() {
      const countryCount = {};

      // Đếm tổng count theo mã quốc gia
      this.shopList.forEach(item => {
        if (item.country) {
          const code = item.country;
          const count = Number(item.count || 0);
          countryCount[code] = (countryCount[code] || 0) + count;
        }
      });

      // Tìm country có count cao nhất
      let topCode = '';
      let maxCount = 0;
      for (const code in countryCount) {
        if (countryCount[code] > maxCount) {
          maxCount = countryCount[code];
          topCode = code;
        }
      }

      // Tìm flag và name từ mảng countryKeys
      const matched = this.countryKeys.find(c => c.code === topCode);

      return {
        code: topCode,
        count: maxCount,
        flag: matched ? matched.flag : '',
        name: matched ? matched.value : topCode,
      };
    },
    // ...mapGetters(['getTrafficLocation', 'getTotalTrafficLocation']),
  },
  watch: {
    dateRange: async function(newTime, currTime) {
      let { stores } = this.loadQueryFromCache();
      let fromTime = newTime
        ? moment(newTime.from).format('YYYY-MM-DD')
        : moment()
            .tz(this.timezone)
            .format('YYYY-MM-DD');
      let toTime =
        newTime && newTime.to
          ? moment(newTime.to).format('YYYY-MM-DD')
          : moment()
              .tz(this.timezone)
              .format('YYYY-MM-DD');
      const filter = this.updateFilterQuery(this.$route.query || {});
      this.fetchRecords(filter);
      await this.$store.dispatch(FETCH_TOTAL_SALES, {
        fromTime,
        toTime,
        stores: this.stores,
        timezone: this.timezone,
      });
    },
    stores: async function(newStores, currStores) {
      let { startDate, endDate } = this.loadQueryFromCache();
      let fromTime = startDate
        ? startDate
        : this.$props.dateRange && this.$props.dateRange.from
        ? moment(this.$props.dateRange.from).format('YYYY-MM-DD')
        : moment()
            .tz(this.timezone)
            .format('YYYY-MM-DD');
      let toTime = endDate
        ? endDate
        : this.$props.dateRange && this.$props.dateRange.to
        ? moment(this.$props.dateRange.to).format('YYYY-MM-DD')
        : moment()
            .tz(this.timezone)
            .format('YYYY-MM-DD');
      const filter = this.updateFilterQuery(this.$route.query || {});
      this.fetchRecords(filter);
      await this.$store.dispatch(FETCH_TOTAL_SALES, { fromTime, toTime, stores: newStores, timezone: this.timezone });
    },
    chartData: function(newData, currData) {
      this.zipChartData();
    },
    globeChart: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.liveViews) {
          this.shopList = newVal.liveViews;
          this.updateGlobeShops();
        }
      },
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeGlobe);
    document.removeEventListener('click', this.clearSelectedShop);
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.live-view {
  width: 100%;
  height: calc(100vh - 64px);
  position: relative;
}

.globe-container {
  width: 100%;
  height: calc(100vh - 64px);
  background-color: #f0f8ff;
  overflow: hidden;
  position: relative;
  inset: 0;
  top: 0;
}

.shop-info-box {
  position: fixed;
  background: rgba(255, 255, 255);
  color: black;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  pointer-events: none;
  z-index: 999;
  max-width: 300px;
  white-space: normal;
  border: 1px solid #bbbbbb;
}

.bold-text {
  font-weight: 600;
}

/* Tooltip label */
.globe-container .hex-tooltip {
  position: absolute;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 100;
  max-width: 200px;
}

.globe-container canvas {
  pointer-events: none !important; /* Đảm bảo canvas không bắt sự kiện */
}
</style>
